import {createId} from "../../../../../utils/projectFactories";
import {updateAtPath} from "./pathUpdate";

function uid(prefix = "id") {
    return `${prefix}_${Math.random().toString(36).slice(2, 9)}_${Date.now().toString(36)}`;
}

export function createEmptyBlocksContainer() {
    return { blocks: [] };
}

export function createEmptyTextBlock() {
    return {
        id: uid("block"),
        type: "text",
        config: { text: "" }
    };
}

export function createEmptyTestCase(template = "python_beginner") {

    const check = createEmptyValidationCheck(template);

    return {

        id: uid("test_case"),

        stdin: "",

        validation: {

            mode: "all",

            checks: [
                check
            ]

        }

    };

}

export function createEmptyCodeBlock() {
    return {
        id: uid("block"),
        type: "code",
        config: {
            language: "javascript",
            code: ""
        }
    };
}

export function createEmptyLinkBlock() {
    return {
        id: createId("block"),
        type: "link",
        config: {
            label: "",
            url: ""
        }
    };
}


export function createEmptyHint() {
    return {
        id: uid("hint"),
        energyCost: 0,
        content: createEmptyBlocksContainer()
    };
}


export function createEmptyEditor(slot = "main") {
    return {
        slot,
        starterCode: ""
    };
}

export function createEditorsForTemplate(template){

    switch(template){

        case "python_beginner":

        case "java_beginner":

        case "cpp_beginner":

            return [

                {

                    slot:"main",

                    starterCode:""

                }

            ];

        case "web_html":

            return [

                {

                    slot:"html",

                    starterCode:""

                }

            ];

        case "web_html_css":

            return [

                {

                    slot:"html",

                    starterCode:""

                },

                {

                    slot:"css",

                    starterCode:""

                }

            ];

        case "web_html_css_js":
            return [

                {

                    slot:"html",

                    starterCode:""

                },

                {

                    slot:"css",

                    starterCode:""

                },

                {

                    slot:"js",

                    starterCode:""

                }

            ];

        case "sqlite_basic":

            return [

                {

                    slot:"sql",

                    starterCode:""

                }

            ];

        default:

            return [];

    }

}

export function createEmptyRunTarget({ resultType = "program", editorId } = {}) {
    const base = {
        id: uid("target"),
        runner: resultType === "sql" ? "sqlite" : resultType === "web" ? "web" : "python",
        resultType, // "program" | "sql" | "web"
    };

    if (resultType === "web") {
        return {
            ...base,
            editorIds: { html: "", css: "", js: "" },
        };
    }

    return {
        ...base,
        editorId: editorId || "",
    };
}

export function createEmptyValidationCheck(template = "python_beginner") {

    switch (template) {

        // --------------------------------------------------
        // PROGRAM
        // --------------------------------------------------

        case "python_beginner":
        case "java_beginner":
        case "cpp_beginner":

            return {
                id: uid("check"),
                kind: "stdout_exact",
                expected: ""
            };


        // --------------------------------------------------
        // HTML
        // --------------------------------------------------

        case "web_html":
        case "web_html_css":
        case "web_html_css_js":

            return {
                id: uid("check"),
                kind: "html_doc_valid"
            };

        // --------------------------------------------------
        // SQL
        // --------------------------------------------------

        case "sqlite_basic":

            return {
                id: uid("check"),
                kind: "row_count",
                count: 0
            };


        default:

            return {
                id: uid("check"),
                kind: "stdout_exact",
                expected: ""
            };

    }

}

export function createEmptyProjectStep(template = "python_beginner") {

    return {

        id: uid("step"),

        instruction: createEmptyBlocksContainer(),

        editors: createEditorsForTemplate(template),

        testCases: [
            createEmptyTestCase(template)
        ],

        feedback: {
            correct: createEmptyBlocksContainer(),
            incorrect: createEmptyBlocksContainer()
        },

        hints: [],

        explain: createEmptyBlocksContainer(),

        solution: {
            editors: {}
        }

    };

}

export function createEmptyProjectPart(template = "python_beginner") {

    return {

        id: uid("part"),

        name: "New Part",

        steps: [

            createEmptyProjectStep(template)

        ]

    };

}